import { memo, PropsWithChildren, ReactNode } from 'react';
import { Button } from 'src/common/Button/Button';
import { FilterIcon } from 'src/modules/common/icons/FilterIcon';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

type Props = {
    title: string;
    isMobile: boolean;
    filterHandler?: () => void;
    subHeader?: ReactNode;
}

export const AccessoryGrid = memo(({
    title,
    isMobile,
    filterHandler,
    subHeader,
    children,
}: PropsWithChildren<Props>) => (
    <div className="vss-accessory-grid">
        <div className="vss-accessory-grid__header">
            <h2 className="vss-accessory-grid__title"><I18n messageId={title}/></h2>
            {subHeader && subHeader}
            <div className="vss-accessory-grid__actions">
                {isMobile && filterHandler && (
                    <Button
                        kind="ghost-secondary"
                        size="md"
                        onClick={filterHandler}
                    >
                        <div className="vss-accessory-grid__action-icon">
                            <FilterIcon/>
                        </div>
                    </Button>
                )}
            </div>
        </div>

        <div className="vss-accessory-grid__list">
            {children}
        </div>
    </div>
));
